export let colWidthArray = [];
export const COL_PREFIX = "col_";
export const DEFAULT_COL_INDEX = Object.freeze({
    rowId: 0, //rowuuid
    experimentId: 1, //실험id
    no: 2, //고유아이디
    sample: 3, //sample
    date: 4, //date
});
export const PROPERTY_TYPE = Object.freeze({
    STRING: {value: "STRING", label: "Text"},
    NUMBER: {value: "NUMBER", label: "Number"},
    DATE: {value: "DATE", label: "Date"},
    ARRAY: {value: "ARRAY", label: "Text Array"},
    NUMBER_ARRAY: {value: "NUMBER_ARRAY", label: "Number Array"},
    FILE: {value: "FILE", label: "File"},
    IMAGE: {value: "IMAGE", label: "Image"}
});

export function districtType() {
    return Object.values(PROPERTY_TYPE).filter(item =>
        [PROPERTY_TYPE.DATE.value, PROPERTY_TYPE.FILE.value, PROPERTY_TYPE.IMAGE.value].includes(item.value)
    ).map(item => {
        return item.value;
    });
}

/*handsontable의 header setting*/
export async function settingHeader($wApi, route, selectedReleaseProcess, customSettings) {
    colWidthArray = [];
    const hiddenColName = "숨김정보";
    const defaultColName = "실험정보";
    const nestedHeaders = [
        [{label: hiddenColName, colspan: 2}, {label: defaultColName, colspan: 3}],
        ["rowId", "experimentId", "고유ID", "샘플명", "날짜"],
    ];
    const hiddenIndexes = [0,1]; //기본 숨김컬럼 index

    // 메인 헤더와 서브 헤더는 서로 의존하지 않으므로 동시에 조회한다.
    const [mainHeaders, subHeaders] = await Promise.all([
        $wApi.dictionary.getReleaseDictionaryKeyLinksByReleaseProcessId({
            idReleaseProcess: selectedReleaseProcess.idReleaseProcess,
        }),
        $wApi.property.getAllReleaseProcessPropertyList({
            processId: route.query.processId,
        }),
    ]);
    
    //사용자 커스텀세팅이 있을 경우 적용
    if (customSettings != null && customSettings.length > 0) {
        mainHeaders.forEach(mainHeader => {
            const customized = customSettings.find(customNode => customNode.dictionaryKeyLinkId == mainHeader.dictionaryKeyLinkId);
            if(customized){
                mainHeader.nodeOrder = customized.nodeCustomOrder;
            }
        })

        subHeaders.forEach(subHeader => {
            const customized = customSettings.flatMap(prop => prop.propertyCustomOrderList).find(propCustom => propCustom.processPropertyId == subHeader.processPropertyId);
            if(customized){
                subHeader.propertyOrder = customized.propertyCustomOrder;
                subHeader.propertyVisible = customized.propertyVisible;
            }
        });
    }

    // 컬럼 헤더명 세팅
    let mainHeaderIndex = 0;
    const sortedMainHeaders = mainHeaders.sort((a, b) => a.nodeOrder - b.nodeOrder);
    sortedMainHeaders.forEach((mainHeader) => {
        // 메인 헤더에 서브 헤더(속성)가 있는지 확인
        const length = subHeaders.filter((subHeader) => mainHeader.dictionaryKeyLinkId === subHeader.dictionaryKeyLinkId).length;
        if (length === 0) return;

        const relatedSubHeaders = subHeaders
            .filter((sub) => sub.dictionaryKeyLinkId === mainHeader.dictionaryKeyLinkId)
            .sort((a, b) => a.propertyOrder - b.propertyOrder);

        mainHeaderIndex = mainHeaderIndex + relatedSubHeaders.length ;
        nestedHeaders[0].push({
            label: mainHeader.tagName,
            colspan: relatedSubHeaders.length,
            key : mainHeader.tagKey,
            mainHeaderIndex : mainHeaderIndex,
            nestedType : 'MainHeader',
        });

        relatedSubHeaders.forEach((subHeader) => {
            nestedHeaders[1].push(
                `${subHeader.propertyName}${
                    subHeader.propertyUnit != null && subHeader.propertyUnit !== ''
                        ? `[${subHeader.propertyUnit}]`
                        : ''
                }`
            );
        });
    });

    // 컬럼 타입 세팅, 컬럼 너비
    const columns = [];

    //숨길 컬럼 추가(실험아이디 및 rowId 세팅), 숨김컬럼은 프론트에서만 사용
    ['rowId', 'experimentId'].forEach((type) => {
        colWidthArray.push(100);
        columns.push({
            type: type == 'rowId' ? "text" : 'numeric',
            readOnly: true,
            propertyType: type == 'rowId' ? PROPERTY_TYPE.STRING.value : PROPERTY_TYPE.NUMBER.value,
            data: COL_PREFIX + type,
            processPropertyType: "HIDDEN", //프론트에서만 사용하는 타입.
            name: type,
            nodeName: hiddenColName
        });
    });

    // 정적 컬럼 추가 (공정도 기본 컬럼 우선 세팅)
    ['NO', 'SAMPLE', 'DATE'].forEach((type) => {
        const column = subHeaders.find((sub) => sub.processPropertyType === type);
        if (!column) throw new Error('기본속성이 존재하지 않습니다. 관리자에게 문의해주세요.');
        columns.push({
            ...matchColumnType(column),
            data: COL_PREFIX + column.processPropertyId,
            processPropertyType: column.processPropertyType,
            name: column.propertyName,
            nodeName: defaultColName
        });
    });

    // 동적 컬럼 추가
    sortedMainHeaders.forEach((main) => {
        const length = subHeaders.filter((subHeader) => main.dictionaryKeyLinkId === subHeader.dictionaryKeyLinkId).length;
        if (length === 0) return;

        const sortedSubHeader = subHeaders
            .filter((sub) => sub.dictionaryKeyLinkId === main.dictionaryKeyLinkId)
            .sort((a, b) => a.propertyOrder - b.propertyOrder);

        sortedSubHeader.forEach((subHeader) => {
            const newIndex = columns.length; // 현재 push될 index 저장

            const columnData = {
                ...matchColumnType(subHeader),
                data: COL_PREFIX + subHeader.processPropertyId,
                key: main.tagKey,
                tagType: main.tagType,
                processPropertyType: subHeader.processPropertyType,
                name: subHeader.propertyName,
                nodeName: main.tagName,
                propertyVisible : subHeader.propertyVisible,
                propertyUnit : subHeader.propertyUnit
            };

            columns.push(columnData);

            // propertyVisible이 false라면 해당 인덱스를 hiddenIndexes 배열에 저장하여 hidden 처리
            if (subHeader.propertyVisible === false) {
                hiddenIndexes.push(newIndex);
            }
        });

/*        const columnArray = sortedSubHeader.map((column) => ({
            ...matchColumnType(column),
            data: COL_PREFIX + column.processPropertyId,
            key: main.tagKey,
            tagType: main.tagType,
            processPropertyType: column.processPropertyType,
            name: column.propertyName,
            nodeName: main.tagName
        }));

        columns.push(...columnArray);*/
    });
    //console.log('nestedHeaders=', nestedHeaders, 'columns=', columns, 'hiddenIndexes',hiddenIndexes);

    return {nestedHeaders, columns, hiddenIndexes};
}

/*현재 사용중인 handsonTalbe의 data를 json으로 반환.*/
export function exportToJson(hotInstance) {
    const rowData = hotInstance.getData();
    const exportData = [];

    rowData.forEach((row, rowIndex) => {
        Object.keys(row).forEach((colKey, colIndex) => {
            const cellValue = row[colIndex];
            const cellRowMeta = hotInstance.getSourceDataAtRow(rowIndex);
            const rowId = hotInstance.getDataAtCell(rowIndex, 0);//rowId 가져오기
            const experimentId = hotInstance.getDataAtCell(rowIndex, 1);//experimentId 가져오기

            const cellColMeta = hotInstance.getColumnMeta(colIndex)
            exportData.push({
                rowId: rowId,
                processPropertyId: cellColMeta.processPropertyId,
                value: cellValue,
                experimentId: experimentId
            });
        });
    });
    console.log('exportData = ', exportData)
}

/*현재 사용중인 Row의 uuid를 반환.*/
export function checkActiveRow(hotInstance) {
    const activeRowArray = [];
    //getSourceData()는 O(N)이라 루프 밖에서 1번만 호출 (기존 행마다 호출 → O(N^2))
    const sourceData = hotInstance.getSourceData();
    const rowLastIndex = sourceData.length - 1;
    for (let i = 0; i <= rowLastIndex; i++) {
        const rowId = sourceData[i]['col_rowId']//rowId 가져오기
        const experimentId = sourceData[i]['col_experimentId']//experimentId 가져오기
        if (
            (rowId == null || rowId == '')
            || (experimentId == null || experimentId == '')
        ) {
            alert('Row 오류가 발생되었습니다. 관리자에게 문의해주세요.');
            throw Error('checkActiveRow Error!')
        }
        activeRowArray.push({
            rowId: rowId,
            rowOrder: i
        });
    }
    //console.log('activeRowArray=',activeRowArray);
    return activeRowArray;
}

/*key로 groupBy*/
export function groupBy(data, key) {
    return Object.entries(data.reduce(function (carry, el) {
        var group = el[key];

        if (carry[group] === undefined) {
            carry[group] = []
        }

        carry[group].push(el)
        return carry
    }, {}));
}

/*handsonTable의 column data type을 반환함.*/
function matchColumnType(column) {
    let columnType = null;
    switch (column.propertyType) {
        case PROPERTY_TYPE.STRING.value:
            if (column.processPropertyType == "NO") {
                columnType = {propertyType: column.propertyType, type: "text", readOnly: true}
                colWidthArray.push(170);
            } else {
                columnType = {propertyType: column.propertyType, type: "text"};
                colWidthArray.push(100);
            }
            break;
        case PROPERTY_TYPE.ARRAY.value:
            columnType = {propertyType: column.propertyType, type: "text"};
            colWidthArray.push(100);
            break;
        case PROPERTY_TYPE.NUMBER_ARRAY.value:
            columnType = {propertyType: column.propertyType, type: "text", validator : custom_validator.number_array};
            colWidthArray.push(100);
            break;
        case PROPERTY_TYPE.NUMBER.value:
            columnType = {propertyType: column.propertyType, type: "numeric"};
            colWidthArray.push(50);
            break;
        case PROPERTY_TYPE.FILE.value:
            columnType = {propertyType: column.propertyType, type: "text", readOnly: true};
            colWidthArray.push(100);
            break;
        case PROPERTY_TYPE.IMAGE.value:
            columnType = {propertyType: column.propertyType, type: "text", readOnly: true};
            colWidthArray.push(100);
            break;
        case PROPERTY_TYPE.DATE.value:
            columnType = {
                propertyType: column.propertyType,
                type: "date",
                dateFormat: "YYYYMMDD",
                correctFormat: false,
                defaultDate: getFormattedTodayDate(), // 현재 날짜로 수정
                datePickerConfig: {
                    format: "YYYYMMDD", // DatePicker 표시 형식
                },
            };
            colWidthArray.push(100);
            break;
        case "EXPONENTIAL":
            columnType = {
                propertyType: column.propertyType,
                type: "numeric",
                format: "0.00e+0",
            };
            colWidthArray.push(50);
            break;
    }
    return columnType;
}

/*날짜포멧*/
export function getFormattedTodayDate(shortFlag) {
    const today = new Date();
    let year;
    if (shortFlag) {
        year = String(today.getFullYear()).slice(2, 4);
    } else {
        year = today.getFullYear();
    }
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}

// 최대 suffix를 저장하는 캐시 객체
const suffixCache = {};

export function initiateUniqueID(data, columnId, affiliation, fullName) {
    const date = getFormattedTodayDate(true);
    const name = fullName.length > 2 ? fullName.slice(fullName.length - 2, fullName.length) : (fullName || 'noName');
    const key = `${affiliation}_${name}_${date}`;

    // 기존 ID를 기준으로 동일한 소속, 이름, 날짜의 행 필터링
    const filtered = data.filter(row => {
        const id = row[columnId]; // ID 값이 없을 경우 빈 문자열 처리
        const [rowAffiliation, rowName, rowDate] = id.split('_');
        return rowAffiliation === affiliation && rowName === name && rowDate === date;
    });

    // 데이터 내에서 최대 suffix 찾기
    const maxSuffix = filtered.reduce((max, row) => {
        const id = row[columnId];
        const parts = id.split('_');
        const suffix = parseInt(parts[3] || "0", 10);
        return Math.max(max, suffix);
    }, 0);

    //초기화 시 suffix 캐시 업데이트
    suffixCache[key] = String(maxSuffix).padStart(4, '0');
    //console.log('key = ',key, 'maxSuffix = ',maxSuffix);
}

/*고유ID생성*/
export function generateUniqueID(data, columnId, affiliation, fullName) {
    const date = getFormattedTodayDate(true);
    const name = fullName.length > 2 ? fullName.slice(fullName.length - 2, fullName.length) : (fullName || 'noName');
    const key = `${affiliation}_${name}_${date}`;

    // 기존 ID를 기준으로 동일한 소속, 이름, 날짜의 행 필터링
    const filtered = data.filter(row => {
        const id = row[columnId]; // ID 값이 없을 경우 빈 문자열 처리
        const [rowAffiliation, rowName, rowDate] = id.split('_');
        return rowAffiliation === affiliation && rowName === name && rowDate === date;
    });

    // 데이터 내에서 최대 suffix 찾기
    const maxSuffixInData = filtered.reduce((max, row) => {
        const id = row[columnId];
        const parts = id.split('_');
        const suffix = parseInt(parts[3] || "0", 10);
        return Math.max(max, suffix);
    }, 0);

    // 캐시에서 최대 suffix 가져오기
    const maxSuffixInCache = suffixCache[key] || 0;

    // 캐시와 데이터 내 최대값 중 더 큰 값 사용
    const maxSuffix = Math.max(maxSuffixInData, maxSuffixInCache);

    // 새 suffix 계산 및 캐시 업데이트
    const newSuffix = String(maxSuffix + 1).padStart(4, '0');
    suffixCache[key] = maxSuffix + 1; // 캐시 갱신

    return `${affiliation}_${name}_${date}_${newSuffix}`;
}

/*노드순서적용*/
export function setNodeOrderByBFS(nodes, links, model) {
    let orderMap = {};
    //깊은복사
    let nodeArray = JSON.parse(JSON.stringify(nodes));
    let linkArray = JSON.parse(JSON.stringify(links));
    try {
        orderMap = assignNumbers(nodeArray, linkArray);
        for (let key in orderMap) {
            const targetData = orderMap[key];
            let nodeData = model.findNodeDataForKey(key);
            if (nodeData) {
                model.setDataProperty(nodeData, "nodeOrder", targetData.nodeOrder);
                model.setDataProperty(nodeData, "nodeForceOrder", targetData.nodeForceOrder);
            }
        }
    } catch (error) {
        console.error(error);
        throw new Error("Invalid JSON");
    }
}

function assignNumbers(nodes, links) {
    // Node를 키로 검색하기 위한 Map
    const nodeMap = new Map();
    // 이미 사용된 번호 추적
    const usedNumbers = new Set();

    //노드 순서정렬 준비
    nodes.forEach(node => {
        //강제순서 지정여부 확인
        if (node.nodeForceOrder && node.nodeForceOrder > 0) {
            node.tempNo = node.nodeForceOrder;
            node.nodeOrder = node.nodeForceOrder;
            usedNumbers.add(node.nodeForceOrder);
        } else {
            node.tempNo = 0; //순서정렬을 위한 값.
        }
        nodeMap.set(node.key, node);
    });

    // 각 노드가 to에 포함되었는지 확인하기 위한 Set
    const toSet = new Set();
    links.forEach(link => {
        if (link.to) {
            toSet.add(link.to);
        }
    });

    // 첫 노드 후보: to가 없는 노드들
    const startCandidates = [];
    nodes.forEach(node => {
        if (!toSet.has(node.key)) {
            startCandidates.push(nodeMap.get(node.key));
        }
    });

    //첫 노드 후보 간 순서정렬
    startCandidates.sort((a, b) => comparePositions(a.position, b.position));

    // Bfs를 통한 순서 배정
    let currentNumber = 1;
    startCandidates.forEach(startNode => {
        /*강제순서가 배정된 노드들은 순서 적용 안하도록 되어있음. 불필요*/
        //모든 시작노드가 강제순서가 배정되었을 경우 첫 시작노드 이후부터 순서지정
        /*if(!startCandidatesAllAssignFlag){
            //tempNo가 0보다 크다면 순서가 배정된 노드
            if (startNode.tempNo > 0 && !startNode.fromFlag){
                return;   
            }   
        }*/

        while (usedNumbers.has(currentNumber)) {
            currentNumber++;
        }
        currentNumber = bfs(startNode, currentNumber, nodeMap, links, usedNumbers);
    });
    return Object.fromEntries(nodeMap);
}

function bfs(startNode, currentNumber, nodeMap, links, usedNumbers) {
    const queue = [];
    queue.push(startNode);

    if (startNode.tempNo === 0) {
        startNode.nodeOrder = currentNumber++;
        usedNumbers.add(startNode.nodeOrder);
    }

    while (queue.length > 0) {
        const current = queue.shift();

        // current 노드에서 출발하는 연결 찾기
        const connectedNodes = [];
        links.forEach(link => {
            if (link.from === current.key) {
                const nextNode = nodeMap.get(link.to);
                connectedNodes.push(nextNode);
            }
        });

        // (x, y) position 정렬
        connectedNodes.sort((a, b) => comparePositions(a.position, b.position));

        // 번호 부여 및 큐에 추가
        connectedNodes.forEach(nextNode => {
            if (nextNode.tempNo === 0) {
                while (usedNumbers.has(currentNumber)) {
                    currentNumber++;
                }
                nextNode.tempNo = currentNumber++;
                nextNode.nodeOrder = nextNode.tempNo;
                usedNumbers.add(nextNode.tempNo);
            }
            queue.push(nextNode);
        });
    }

    return currentNumber;
}

/*function comparePositions(posA, posB) {
    const [xA, yA] = posA.split(" ").map(Number);
    const [xB, yB] = posB.split(" ").map(Number);
    if (xA !== xB) return xA - xB;
    return yA - yB;
}*/

function comparePositions(posA, posB) {
    const [xA, yA] = posA.split(" ").map(Number);
    const [xB, yB] = posB.split(" ").map(Number);
    const weightedA = xA * 2 + yA * 4;
    const weightedB = xB * 2 + yB * 4;
    return weightedA - weightedB;
}

const custom_validator = {
    /*number_array 검증. 숫자형태의 ,로 구분되어있는 형태*/
    number_array: function (query, callback) {
        let flag = true;
        query.split(',').forEach(item =>{
            if(isNaN(item.trim())){
                flag = false;
            }
        })
        callback(flag);
    }
}
